import { Box, Flex, Stack } from '@chakra-ui/react'
import React from 'react'
import Footer from './Footer'
import NavBar from './NavBar'
import SideBar from './SideBar'

export default function MainLayout({ children, bgColor = "blue.blue100", layoutColor = "gray.gray200", color = "black" }) {
  return (

    <Box bgColor={bgColor} minH="100vh"  >
      

      <Flex pos={"relative"} direction={["column-reverse", "column-reverse", "column-reverse", "column-reverse", "row"]} justifyContent="space-between" alignItems={"flex-start"}>
        <Box display={["none", "none", "none", "none", "block"]} w={"30%"} pos={"fixed"} height={"100vh"} >
          <SideBar />
        </Box>

        <Box width={['100%', '100%', '100%', '100%', '100%']} ml={["0%","0%","0%","0%","24%"]} overflow={"auto"}>
        <NavBar />
          <Box borderRadius="8px" mt="10px" p="20px" color={color} mr="0px" minH='87vh' width={['100%', '100%', '100%', '100%', '98.5%']} bgColor={layoutColor}>
            {children}
          </Box>


        </Box>
      </Flex>



    </Box>
  )
}
